


































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import SlideBar from './SlideBar.vue'
import { ExamTestQuestion, GroupExamTestQuestion, GroupQuestion } from '../../../api/v2/models/question'
import { LETTER_FORMAT } from '../../utils/constants'
import Exam from "../../../api/v2/models/exam";

@Component({
  components: {
    SlideBar
  }
})
export default class QuestionGroupTestList extends Vue {
  @Prop({ required: true }) groupExamTestQuestion: GroupExamTestQuestion
  @Prop({ default: true }) padding: boolean
  @Prop({ required: true }) questionNumber: number
  @Prop({ default: false }) active: boolean
  @Prop({ default: false}) isExamResultAfterQuestion: boolean
  @Prop({ default: ()=>{return []} }) groupQuestions: GroupQuestion[]
  @Prop({}) exam: Exam

  get groupQuestion(){
    return this.groupQuestions.find(item => item.groupId == this.groupExamTestQuestion.groupId) || null
  }

  get currentQuestion(): ExamTestQuestion {
    return this.groupExamTestQuestion.questions[0]
  }

  get title() {
    if (this.currentQuestion.isDescriptionQuestion) {
      return this.$t('question.description', { format: LETTER_FORMAT.UPTITLECASE })
    }

    return `${this.$t('question.problem')} ${this.questionNumber}`
  }

  get userScore() {
    return this.groupQuestion ? this.groupQuestion.userScore : 0
  }

  get maxScore() {
    return this.groupQuestion ? this.groupQuestion.maxScore : 0
  }

  get isPass() {
    if (this.exam.autoDiagnosisEnabled) { return false }
    return this.userScore === this.maxScore
  }

  get isNotFullScore() {
    if (this.exam.autoDiagnosisEnabled) { return false }
    return this.userScore < this.maxScore && this.userScore > 0
  }

  get isNotPass() {
    if (this.exam.autoDiagnosisEnabled) { return false }
    return this.userScore === 0
  }

  onClick() {
    this.$emit('click', this.currentQuestion.id.toString())
  }
}
